import { CouponApplyErrorCode } from "../../core/enums";
import { CouponApplyPhase } from "./interfaces/coupon-qualifier.interface";
export class ProfileRequiredQualifier {
    phase = CouponApplyPhase.PreApply;
    _isLoggedIn;
    constructor(isLoggedIn) {
        this._isLoggedIn = isLoggedIn;
    }
    qualify(coupon, _) {
        if (coupon.isProfileRequired && !this._isLoggedIn) {
            return { isValid: false, errorCode: CouponApplyErrorCode.PROFILE_REQUIRED };
        }
        return { isValid: true, errorCode: null };
    }
}
//# sourceMappingURL=profile-required.js.map